const kuIndoLayer4 = [
  [
    [
      96.7413017,
      12.1515057
    ],
    [
      98.9825126,
      11.4632626
    ],
    [
      101.2676689,
      10.8165066
    ],
    [
      102.3925781,
      10.5310207
    ],
    [
      103.113372,
      10.0385613
    ],
    [
      104.0185547,
      9.3623522
    ],
    [
      104.9151298,
      8.4337204
    ],
    [
      105.7763672,
      7.6674421
    ],
    [
      106.628997,
      6.9530718
    ],
    [
      107.3583984,
      6.4899833
    ],
    [
      108.1231376,
      5.9924493
    ],
    [
      110.1269531,
      5.8783328
    ],
    [
      111.1816406,
      6.0531613
    ],
    [
      112.5,
      6.1405548
    ],
    [
      114.5214844,
      6.4463191
    ],
    [
      115.6201172,
      6.708254
    ],
    [
      116.472747,
      6.9094477
    ],
    [
      118.9336845,
      7.0403079
    ],
    [
      120.8056641,
      6.8828002
    ],
    [
      122.34375,
      7.0572824
    ],
    [
      124.497073,
      7.5803271
    ],
    [
      126.448333,
      7.6940423
    ],
    [
      128.4521484,
      7.8416152
    ],
    [
      129.5684501,
      7.694043
    ],
    [
      130.3857422,
      7.4060471
    ],
    [
      131.1065361,
      6.9966926
    ],
    [
      132.8643486,
      5.2927363
    ],
    [
      133.8134766,
      4.4778578
    ],
    [
      134.885833,
      4.0225571
    ],
    [
      136.0986328,
      3.6888565
    ],
    [
      139.2803642,
      2.9698475
    ],
    [
      140.625,
      2.4162757
    ],
    [
      141.4336845,
      1.7843663
    ],
    [
      142.2509766,
      1.1425024
    ],
    [
      142.7520439,
      0.510234
    ],
    [
      144.2285156,
      -1.5818303
    ],
    [
      144.5361382,
      -2.5479879
    ],
    [
      144.729583,
      -3.5743526
    ],
    [
      144.6240234,
      -5.4410223
    ],
    [
      144.6679688,
      -6.1405548
    ],
    [
      144.8876953,
      -6.8391696
    ],
    [
      145.0811455,
      -7.7714836
    ],
    [
      145.2392632,
      -8.7547947
    ],
    [
      145.1250908,
      -9.7692256
    ],
    [
      144.7119141,
      -10.4013776
    ],
    [
      144.2022392,
      -10.8932603
    ],
    [
      143.0419922,
      -11.3507967
    ],
    [
      141.3720703,
      -11.4369552
    ],
    [
      140.4492188,
      -11.5661411
    ],
    [
      139.3066406,
      -11.4369552
    ],
    [
      137.0830986,
      -11.2382858
    ],
    [
      135.8086845,
      -11.3244782
    ],
    [
      133.9629814,
      -11.6689864
    ],
    [
      132.3370048,
      -12.0560469
    ],
    [
      130.7110283,
      -12.6999
    ],
    [
      129.1552734,
      -13.5392007
    ],
    [
      126.8877861,
      -14.6639149
    ],
    [
      124.8223564,
      -15.6395073
    ],
    [
      123.6621094,
      -16.0035757
    ],
    [
      122.4932548,
      -16.2732858
    ],
    [
      120.4278251,
      -16.4840955
    ],
    [
      119.2675781,
      -16.3833937
    ],
    [
      118.4063408,
      -16.1888983
    ],
    [
      117.2021484,
      -15.7076654
    ],
    [
      116.0332939,
      -15.4701642
    ],
    [
      114.7851563,
      -15.4113194
    ],
    [
      113.3526298,
      -15.8087104
    ],
    [
      111.9287109,
      -16.0035757
    ],
    [
      110.4522392,
      -15.9777721
    ],
    [
      108.896483,
      -15.5807107
    ],
    [
      107.463958,
      -14.9613087
    ],
    [
      105.9082045,
      -14.4772342
    ],
    [
      103.3154297,
      -13.9660541
    ],
    [
      101.6192314,
      -13.2993639
    ],
    [
      100.3710938,
      -12.0393206
    ],
    [
      99.597747,
      -10.3749752
    ],
    [
      99.1845703,
      -9.3623528
    ],
    [
      98.4112236,
      -8.5979324
    ],
    [
      97.6025391,
      -7.7109943
    ],
    [
      96.5215751,
      -7.2050691
    ],
    [
      94.7198173,
      -6.2012494
    ],
    [
      94.21875,
      -5.6597186
    ],
    [
      94.21875,
      -5.0033943
    ],
    [
      94.5263672,
      -4.1711155
    ],
    [
      94.7198173,
      -3.3550278
    ],
    [
      94.4824219,
      -2.2845507
    ],
    [
      94.1748047,
      -1.6696868
    ],
    [
      93.7090751,
      -1.2474732
    ],
    [
      92.9882809,
      -0.5273363
    ],
    [
      91.5820313,
      0.6152226
    ],
    [
      90.3252861,
      2.0039727
    ],
    [
      89.604492,
      3.0746937
    ],
    [
      89.2705986,
      4.3293573
    ],
    [
      89.2089844,
      6.1405548
    ],
    [
      89.4463798,
      7.9552596
    ],
    [
      89.7802736,
      9.2756222
    ],
    [
      90.3692314,
      10.4709941
    ],
    [
      91.3623047,
      11.5230875
    ],
    [
      92.4346611,
      12.1515064
    ],
    [
      93.8232422,
      12.5116647
    ],
    [
      94.8779297,
      12.3829283
    ],
    [
      95.8623955,
      12.3662227
    ],
    [
      96.7413017,
      12.1515057
    ]
  ]
]
const kuIndoLayer3 = [
  [
    [
      94.2803642,
      10.7301658
    ],
    [
      93.3135673,
      10.4709941
    ],
    [
      92.7246094,
      10.0554027
    ],
    [
      92.1709892,
      9.6055513
    ],
    [
      91.7138672,
      9.0587022
    ],
    [
      91.2304688,
      8.015716
    ],
    [
      91.1865234,
      6.6646082
    ],
    [
      91.3360283,
      5.4677431
    ],
    [
      91.7578128,
      3.9080989
    ],
    [
      92.0654297,
      3.1624555
    ],
    [
      92.4346611,
      2.3113714
    ],
    [
      93.3837891,
      1.0985655
    ],
    [
      94.5703125,
      -0.0439453
    ],
    [
      95.6426689,
      -1.2035379
    ],
    [
      96.3720703,
      -2.3723687
    ],
    [
      97.0049736,
      -4.1443438
    ],
    [
      97.6904297,
      -5.3535214
    ],
    [
      98.4551689,
      -6.2886184
    ],
    [
      99.9053642,
      -8.0326516
    ],
    [
      100.4150391,
      -8.8850717
    ],
    [
      100.9161064,
      -9.8991243
    ],
    [
      101.4697266,
      -11.1352871
    ],
    [
      102.4541923,
      -12.1419851
    ],
    [
      103.7109388,
      -12.7689464
    ],
    [
      105.8379814,
      -13.0854362
    ],
    [
      107.7539063,
      -13.282719
    ],
    [
      109.3798828,
      -13.5819209
    ],
    [
      111.0058594,
      -13.624636
    ],
    [
      112.7373955,
      -13.5131029
    ],
    [
      114.2138672,
      -13.2827216
    ],
    [
      115.7256767,
      -13.3848823
    ],
    [
      117.2021484,
      -13.5819183
    ],
    [
      118.713958,
      -14.0252901
    ],
    [
      121.0693386,
      -14.4346802
    ],
    [
      122.9150391,
      -14.4346802
    ],
    [
      123.8818359,
      -14.2217886
    ],
    [
      124.8046875,
      -13.6673409
    ],
    [
      128.1884766,
      -11.996341
    ],
    [
      129.5068359,
      -11.2646122
    ],
    [
      130.6231376,
      -10.4181991
    ],
    [
      131.8798855,
      -9.2756222
    ],
    [
      132.7325126,
      -8.2936516
    ],
    [
      133.1982422,
      -7.5803305
    ],
    [
      133.3038017,
      -6.5069765
    ],
    [
      133.2421875,
      -5.6159858
    ],
    [
      132.9082939,
      -4.7139244
    ],
    [
      131.6338798,
      -3.3111568
    ],
    [
      131.0009766,
      -2.5479892
    ],
    [
      130.9747001,
      -1.95032
    ],
    [
      131.0009766,
      -1.3182431
    ],
    [
      131.2823173,
      -0.8080918
    ],
    [
      131.8359375,
      0.219726
    ],
    [
      131.941497,
      1.3450781
    ],
    [
      131.5459892,
      2.3991877
    ],
    [
      130.8868095,
      3.5402125
    ],
    [
      129.7442314,
      4.7236307
    ],
    [
      128.9355496,
      5.2222465
    ],
    [
      128.2763672,
      5.3535214
    ],
    [
      127.4414063,
      5.3535227
    ],
    [
      126.6064453,
      5.3535214
    ],
    [
      125.5078152,
      5.2222465
    ],
    [
      123.1787083,
      4.6530786
    ],
    [
      121.3769531,
      4.434044
    ],
    [
      120.1641533,
      4.3293573
    ],
    [
      118.5644504,
      4.2587684
    ],
    [
      117.9492188,
      4.1272853
    ],
    [
      116.3671875,
      3.6888551
    ],
    [
      114.9786064,
      3.49635
    ],
    [
      113.7744141,
      3.4695586
    ],
    [
      112.5616142,
      3.5840729
    ],
    [
      110.276458,
      3.49635
    ],
    [
      108.8525391,
      3.5572827
    ],
    [
      107.8594658,
      4.1102265
    ],
    [
      106.875,
      4.6092781
    ],
    [
      105.925872,
      5.380246
    ],
    [
      104.2120048,
      6.822188
    ],
    [
      103.3593737,
      7.5367643
    ],
    [
      102.7880846,
      7.9721977
    ],
    [
      102.0147392,
      8.3902486
    ],
    [
      101.1181641,
      8.8850717
    ],
    [
      100.0811455,
      9.3021125
    ],
    [
      97.5323173,
      10.2548519
    ],
    [
      95.8447266,
      10.7037917
    ],
    [
      94.2803642,
      10.7301658
    ]
  ]
]
const kuIndoLayer2 = [
  [
    [
      99.9316406,
      -3.5572827
    ],
    [
      100.9600517,
      -4.7577197
    ],
    [
      101.6015625,
      -5.7471754
    ],
    [
      102.2167969,
      -7.1008927
    ],
    [
      102.9815361,
      -8.5979324
    ],
    [
      103.7548815,
      -9.7090571
    ],
    [
      104.7393486,
      -10.2885097
    ],
    [
      105.8203125,
      -10.5742247
    ],
    [
      106.8926689,
      -10.5910342
    ],
    [
      108.5186455,
      -10.5478345
    ],
    [
      110.6280205,
      -10.6774153
    ],
    [
      112.7813408,
      -10.8932603
    ],
    [
      114.2138672,
      -11.0921659
    ],
    [
      115.5761719,
      -11.2215103
    ],
    [
      118.1866142,
      -11.0658238
    ],
    [
      119.5489176,
      -10.8501037
    ],
    [
      120.234375,
      -10.7901408
    ],
    [
      120.8496067,
      -10.9196178
    ],
    [
      121.3946207,
      -11.1520676
    ],
    [
      122.2119141,
      -11.3938766
    ],
    [
      123.3105469,
      -11.3938819
    ],
    [
      124.0136719,
      -11.3938766
    ],
    [
      124.6905191,
      -11.1089489
    ],
    [
      126.9317301,
      -10.1155077
    ],
    [
      127.96875,
      -9.3623555
    ],
    [
      128.7774332,
      -8.3371349
    ],
    [
      129.0234402,
      -7.3188817
    ],
    [
      128.6895426,
      -6.1138658
    ],
    [
      128.0566406,
      -5.2222465
    ],
    [
      127.0458984,
      -4.434044
    ],
    [
      126.3427708,
      -3.8642546
    ],
    [
      125.4815347,
      -3.7497749
    ],
    [
      124.6289063,
      -3.8204081
    ],
    [
      123.7237222,
      -4.2319997
    ],
    [
      122.7392551,
      -4.959615
    ],
    [
      122.0098551,
      -5.7641909
    ],
    [
      121.684573,
      -6.4026484
    ],
    [
      121.1309488,
      -6.8125176
    ],
    [
      120.2783203,
      -6.6646076
    ],
    [
      119.5489176,
      -6.026468
    ],
    [
      118.3447292,
      -5.134716
    ],
    [
      117.7294895,
      -4.6530799
    ],
    [
      116.9121988,
      -4.1443438
    ],
    [
      116.1035156,
      -3.6888551
    ],
    [
      115.2246094,
      -3.513421
    ],
    [
      113.2647379,
      -3.0917733
    ],
    [
      112.1044922,
      -2.5479879
    ],
    [
      111.2871988,
      -1.6867812
    ],
    [
      110.0567301,
      -0.1049936
    ],
    [
      108.6504801,
      0.8178302
    ],
    [
      106.5411051,
      1.6525897
    ],
    [
      104.9853516,
      2.4162757
    ],
    [
      103.9922769,
      3.1453784
    ],
    [
      102.7880846,
      3.9957805
    ],
    [
      101.6631754,
      4.9425758
    ],
    [
      100.2392578,
      6.1405554
    ],
    [
      98.8067301,
      7.171132
    ],
    [
      97.075196,
      7.7545373
    ],
    [
      95.8007813,
      7.8416152
    ],
    [
      95.0097656,
      7.6674415
    ],
    [
      94.3682535,
      7.0839205
    ],
    [
      93.9550781,
      6.4899833
    ],
    [
      93.8848551,
      5.6864294
    ],
    [
      93.9111328,
      4.6530799
    ],
    [
      94.1485269,
      3.6717874
    ],
    [
      94.6142578,
      2.767478
    ],
    [
      95.2911051,
      1.9600536
    ],
    [
      96.9873047,
      0.351559
    ],
    [
      98.1475504,
      -1.0277901
    ],
    [
      99.1143472,
      -2.6089744
    ],
    [
      99.9316406,
      -3.5572827
    ]
  ]
]
const kuIndoLayer1 = [
  [
    [
      91.1163004,
      -11.0226924
    ],
    [
      91.0299683,
      -11.0431434
    ],
    [
      90.9501457,
      -11.0818971
    ],
    [
      90.8773613,
      -11.1393308
    ],
    [
      90.8274078,
      -11.2102389
    ],
    [
      90.7954788,
      -11.273199
    ],
    [
      90.7735062,
      -11.3442347
    ],
    [
      90.7553101,
      -11.4132321
    ],
    [
      90.7549667,
      -11.4551259
    ],
    [
      90.7647379,
      -11.496785
    ],
    [
      90.7965088,
      -11.5355338
    ],
    [
      90.8353043,
      -11.5711866
    ],
    [
      90.8885193,
      -11.601626
    ],
    [
      90.9463692,
      -11.6283615
    ],
    [
      91.0078239,
      -11.6567752
    ],
    [
      91.0704803,
      -11.6796366
    ],
    [
      91.137085,
      -11.6967854
    ],
    [
      91.204191,
      -11.7120202
    ],
    [
      91.2508965,
      -11.7159474
    ],
    [
      91.299305,
      -11.7152744
    ],
    [
      91.350975,
      -11.7137632
    ],
    [
      91.3932037,
      -11.7068676
    ],
    [
      91.5686417,
      -11.6660135
    ],
    [
      91.7085457,
      -11.6157506
    ],
    [
      91.8395233,
      -11.5607586
    ],
    [
      91.859436,
      -11.5415887
    ],
    [
      91.8724823,
      -11.5192173
    ],
    [
      91.883812,
      -11.490791
    ],
    [
      91.8844986,
      -11.4620236
    ],
    [
      91.8745422,
      -11.4088561
    ],
    [
      91.8573761,
      -11.3614005
    ],
    [
      91.7863083,
      -11.2346488
    ],
    [
      91.7198753,
      -11.1192877
    ],
    [
      91.6707802,
      -11.0653816
    ],
    [
      91.6391945,
      -11.0426364
    ],
    [
      91.5996988,
      -11.0226924
    ],
    [
      91.5401459,
      -11.0133192
    ],
    [
      91.480751,
      -11.0101182
    ],
    [
      91.3590431,
      -11.0092773
    ],
    [
      91.2356186,
      -11.0101182
    ],
    [
      91.1163004,
      -11.0226924
    ]
  ]
]

const KuIndonesia = {
  sourceLayer4: {
    'type': 'geojson',
    'data': {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': kuIndoLayer4
      }
    }
  },
  sourceLayer3: {
    'type': 'geojson',
    'data': {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': kuIndoLayer3
      }
    }
  },
  sourceLayer2: {
    'type': 'geojson',
    'data': {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': kuIndoLayer2
      }
    }
  },
  sourceLayer1: {
    'type': 'geojson',
    'data': {
      'type': 'Feature',
      'geometry': {
        'type': 'Polygon',
        'coordinates': kuIndoLayer1
      }
    }
  },
  fillLayer4: {
    'id': 'ku-indo-fill4',
    'type': 'fill',
    'source': 'ku-indo-source4',
    'layout': {},
    'paint': {
      'fill-color': 'rgba(148, 22, 8, 0.3)'
    }
  },
  lineLayer4: {
    'id': 'ku-indo-line4',
    'type': 'line',
    'source': 'ku-indo-source4',
    'layout': {},
    'paint': {
      "line-color": "#000",
      "line-width": 2
    }
  },
  fillLayer3: {
    'id': 'ku-indo-fill3',
    'type': 'fill',
    'source': 'ku-indo-source3',
    'layout': {},
    'paint': {
      'fill-color': 'rgba(148, 22, 8, 0.4)'
    }
  },
  lineLayer3: {
    'id': 'ku-indo-line3',
    'type': 'line',
    'source': 'ku-indo-source3',
    'layout': {},
    'paint': {
      "line-color": "#000",
      "line-width": 2
    }
  },
  fillLayer2: {
    'id': 'ku-indo-fill2',
    'type': 'fill',
    'source': 'ku-indo-source2',
    'layout': {},
    'paint': {
      'fill-color': 'rgba(148, 22, 8, 0.5)',
      'fill-opacity': 0.4,
    }
  },
  lineLayer2: {
    'id': 'ku-indo-line2',
    'type': 'line',
    'source': 'ku-indo-source2',
    'layout': {},
    'paint': {
      "line-color": "#000",
      "line-width": 2
    }
  },
  fillLayer1: {
    'id': 'ku-indo-fill1',
    'type': 'fill',
    'source': 'ku-indo-source1',
    'layout': {},
    'paint': {
      'fill-color': 'rgba(148, 22, 8, 0.6)',
      'fill-opacity': 0.4,
    }
  },
  lineLayer1: {
    'id': 'ku-indo-line1',
    'type': 'line',
    'source': 'ku-indo-source1',
    'layout': {},
    'paint': {
      "line-color": "#000",
      "line-width": 2
    }
  }
}

export function KuIndonesiaMap(map) {
  map.addSource('ku-indo-source4', KuIndonesia.sourceLayer4);
  map.addSource('ku-indo-source3', KuIndonesia.sourceLayer3);
  map.addSource('ku-indo-source2', KuIndonesia.sourceLayer2);
  map.addSource('ku-indo-source1', KuIndonesia.sourceLayer1);

  map.addLayer(KuIndonesia.fillLayer4);
  map.addLayer(KuIndonesia.fillLayer3);
  map.addLayer(KuIndonesia.fillLayer2);
  map.addLayer(KuIndonesia.fillLayer1);

  map.addLayer(KuIndonesia.lineLayer4);
  map.addLayer(KuIndonesia.lineLayer3);
  map.addLayer(KuIndonesia.lineLayer2);
  map.addLayer(KuIndonesia.lineLayer1);
  return map;
}